import { Task } from "gantt-task-react"
import styles from "./task-list-table.module.css"
import {
  gantChartDataSelector,
  gantSelectionChange,
  selectedRunDetailsSelector,
  setRunDetails,
  updateGantSelectionLabel,
} from "../MonitorSlice"
import { createUseStyles, useTheme } from "react-jss"
import { PIPELINE_NAMES_MAPPER } from "../../../util/StaticData"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import { Box } from "@mui/material"
import {
  endDateChange,
  pipeLineNamesAndRunIdsAsync,
  startDateChange,
} from "../FilterSlice"
import airflowIcon from "../../../icons/airflow.svg"
import dataFactory from "../../../icons/adf.svg"

const useStyles = createUseStyles({
  label: {
    color: "#000",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    lineHeight: "150%",
    justifySelf: "center",
    alignSelf: "center",
    cursor: "pointer",
  },
})

const getDisplayValue = (task: any, isname: boolean, isProject?: string) => {
  if (task.scheduled) {
    return <div>&emsp;{" Scheduled Run"}</div>
  }
  return isname ? (
    task.id
  ) : (
    <div>
      {PIPELINE_NAMES_MAPPER[task.id] ? (
        PIPELINE_NAMES_MAPPER[task.id]
      ) : (
        <div style={{ display: "flex", gap: "10px" }}>
          &emsp;{task.id}
          {isProject && isProject === "project" ? (
            <img
              src={task.id.includes("airflow") ? airflowIcon : dataFactory}
              width={15}
              height={15}
              alt="icon"
            />
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  )
}

export const TaskListTableDefault: React.FC<{
  rowHeight: number
  fontFamily: string
  fontSize: string
  tasks: any
  selectedTaskId: string
  setSelectedTask: (taskId: string) => void
  onExpanderClick: (task: Task) => void
}> = ({ rowHeight, tasks, fontFamily, fontSize, onExpanderClick }) => {
  const dispatch = useAppDispatch()
  const theme: any = useTheme()
  const classes = useStyles({ theme })
  const gantSeries: any = useAppSelector(gantChartDataSelector)
  const changeMarket = (task: Task) => {
    const obj = gantSeries.find(
      (ob: any) => ob["extra"]["name"] === task.project,
    )
    const run = obj.extra.runs.find((obj: any) => {
      return obj.az_pipeline_run_id === task.id
    })

    dispatch(setRunDetails(run))
    dispatch(gantSelectionChange(obj))
    dispatch(updateGantSelectionLabel(obj.name))
    dispatch(startDateChange(""))
    dispatch(endDateChange(""))
    dispatch(pipeLineNamesAndRunIdsAsync())
  }
  const activeRunDetails = useAppSelector(selectedRunDetailsSelector)

  return (
    <Box
      className={styles.taskListWrapper}
      sx={{
        fontFamily: fontFamily,
        fontSize: fontSize,
      }}
    >
      {tasks.map((t: any) => {
        let expanderSymbol = ""
        if (t.hideChildren === false) {
          expanderSymbol = "▼"
        } else if (t.hideChildren === true) {
          expanderSymbol = "▶"
        }

        const isname = t.name === t.id
        return (
          <Box
            className={styles.taskListTableRow}
            sx={{
              height: rowHeight,
              alignItems: "center",
              display: t["showToolTip"] ? "flex" : "",
            }}
            key={`${t.id}row`}
          >
            <Box
              className={styles.taskListCell}
              sx={{
                minWidth: 320,
                maxWidth: 320,
              }}
              title={t.id}
            >
              <div className={styles.taskListNameWrapper}>
                <button
                  className={
                    expanderSymbol
                      ? styles.taskListExpander
                      : t["showToolTip"]
                      ? ""
                      : styles.taskListEmptyExpander
                  }
                  onClick={() => onExpanderClick(t)}
                >
                  {expanderSymbol}
                </button>

                <div
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color:
                      activeRunDetails?.az_pipeline_run_id === t.id
                        ? "red"
                        : "inherit",
                  }}
                  onClick={() => {
                    if (t.type === "task" && !t.scheduled) {
                      changeMarket(t)
                    }
                  }}
                  className={classes.label}
                >
                  {getDisplayValue(t, isname, t.type)}
                </div>
              </div>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}
